import React, { Component } from 'react'

// react slick
import Slider from "react-slick";

// when no image found
import noImgFoundImg from 'assets/images/no-img.png'

export default class ProductSlider extends Component {
    constructor(props) {
        super(props);
        // state
        this.state = {
            nav1: null,
            nav2: null
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2
        });
    }

    render() {
        // consts
        const largeSliderSettings = {
            slidesToShow: 1,
            adaptiveHeight: true,

            speed: 500,
            slidesToScroll: 1,
            infinite: false,
        };
        const thumbSliderSettings = {
            vertical: true,
            slidesToShow: 5,
            swipeToSlide: true,
            focusOnSelect: true,
            arrows: false,

            speed: 500,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        };

        return (
            <div className="slider-inner">

                {/* thumb slider */}
                <div className="thumb-slider">
                    <div className="inner">
                        <Slider
                            {...thumbSliderSettings}
                            asNavFor={this.state.nav1}
                            ref={slider => (this.slider2 = slider)}
                        >
                            {
                                this.props.productImages?.length ? this.props.productImages.map((item, index) => (
                                    <div key={index} data-hash={"slide " + index} className="thumb-item">
                                        <div className="img-view text-center">
                                            <img
                                                src={item}
                                                alt="slider"
                                                className="img-fluid"
                                                onLoad={ev => ev.target.parentNode.classList.add("loaded")}
                                            />
                                        </div>
                                    </div>
                                )) : (
                                    <div className="thumb-item">
                                        <div className="img-view text-center">
                                            {
                                                !this.props.productsDetailsLoading ? (
                                                    <img
                                                        src={noImgFoundImg}
                                                        alt="no img found"
                                                        className="img-fluid"
                                                        onLoad={ev => ev.target.parentNode.classList.add("loaded")}
                                                    />
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </Slider>
                    </div>
                </div>

                {/* main slider */}
                <div className="main-slider">
                    <Slider
                        {...largeSliderSettings}
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                    >
                        {
                            this.props.productImages?.length ? this.props.productImages.map((item, index) => (
                                <div key={index} data-hash={"slide " + index} className="slider-item">
                                    <div className="img-view text-center">
                                        <img
                                            src={item}
                                            alt="slider"
                                            className="img-fluid"
                                            onLoad={ev => ev.target.parentNode.classList.add("loaded")}
                                        />
                                    </div>
                                </div>
                            )) : (
                                <div className="slider-item">
                                    <div className="img-view text-center">
                                        {
                                            !this.props.productsDetailsLoading ? (
                                                <img
                                                    src={noImgFoundImg}
                                                    alt="no img found"
                                                    className="img-fluid"
                                                    onLoad={ev => ev.target.parentNode.classList.add("loaded")}
                                                />
                                            ) : null
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </Slider>
                </div>
            </div>
        )
    }
}
